import { render, staticRenderFns } from "./PrivatyContent.vue?vue&type=template&id=1bec4f1e&scoped=true&"
import script from "./PrivatyContent.vue?vue&type=script&lang=js&"
export * from "./PrivatyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec4f1e",
  null
  
)

export default component.exports